//公司文字介绍
export const companyProfile = [
	//公司文字介绍
	'杭州捷途慧声科技有限公司是深耕行业AI的解决方案供应商。具有多年的人工智能行业从业经验，主要专注于智能语音、智能图像、自然语义理解等人工智能技术的研究与应用。',
	'公司核心技术依托人工智能领域的深入学术研究和强大科研力量，并不断地在此基础上探索，打造AI+行业，推动人工智能与行业的融合创新，形成独具特色的研发成果。公司在智能语音领域的不断研发，结合对行业业务的深刻理解，为公安、法院、检察院、海关等公检法行业用户提供基于人工智能技术的语音识别和图像识别应用的解决方案和产品。项目覆盖全国各省市县，旨在实现对AI技术的需求，服务广大用户，提供专业的技术解决方案。',
	'为了不断地完善产品的设计，满足政法行业国产化需求，同飞腾、华为和长城等合作伙伴之间相互配合，共同做出努力。打造全方位支持的语音识别和图像识别产品及解决方案，助力行业信息化的建设发展，全面提升行业智能化水平。',
	'未来，捷途慧声将秉承“聚焦 创新 执行 分享”的核心价值，坚持“以人为本、技术创新、专注产品、用心服务”的行动准则，以“建设具备行业影响力的人工智能服务商”为愿景，不断开拓创新，为智能化产业发展贡献力量。',
]
//里程碑详情描述（按设计稿由近及远）
export const companyMilestoneList = [
	{
		title: 'AI大模型',
		content: [
			'发布行业大模型智能体与边缘便携式一体机',
			'成功获评省级专精特新中小企业',
		],
		timestamp: '2024-2026',
	},
	{
		title: '行业深耕',
		content: [
			'深化信创生态适配，多款产品完成国产平台认证并收录信创图谱',
			'成立沈阳分公司',
			'加入openKylin社区',
			'发布机架式语音识别系统、智能语音质检方案及信创计算盒子',
			'荣获中国软件技术人工智能标杆企业奖等多项荣誉',
		],
		timestamp: '2021-2023',
	},
	{
		title: '自主可控',
		content: [
			'自主研发ASR、NLP、OCR核心算法，推出语音助手产品',
			'获评国家高新技术企业及杭州市“雏鹰计划”企业',
			'核心产品完成与华为鲲鹏、统信等国产软硬件的兼容性认证',
		],
		timestamp: '2019-2020',
	},
	{
		title: '标杆落地',
		content: [
			'研发智能语音庭审与电子卷宗系统',
			'落地某铁路法院、浙江某公安等标杆项目',
			'获评浙江省科技型中小企业',
			'荣获省公安厅创新金奖',
		],
		timestamp: '2017-2018',
	},
	{
		title: '成立与破局',
		content: [
			'杭州捷途慧声科技有限公司正式成立',
			'依托人工智能技术',
			'重点拓展政法行业智能语音技术应用',
		],
		timestamp: '2016',
	},
]

//企业荣誉，
export const horizontalImg = [
	{
		src: window.imgUrl + '/enterprise39.jpg',
	},
	{
		src: window.imgUrl + '/enterprise40.jpg',
	},
	{
		src: window.imgUrl + '/enterprise41.jpg',
	},
	{
		src: window.imgUrl + '/enterprise42.jpg',
	},
	{
		src: window.imgUrl + '/enterprise43.jpg',
	},
	{
		src: window.imgUrl + '/enterprise44.jpg',
	},
	{
		src: window.imgUrl + '/enterprise45.jpg',
	},
	{
		src: window.imgUrl + '/enterprise46.jpg',
	},
	{
		src: window.imgUrl + '/enterprise47.jpg',
	},
	{
		src: window.imgUrl + '/enterprise48.jpg',
	},
	{
		src: window.imgUrl + '/enterprise1.jpg',
	},
	{
		src: window.imgUrl + '/enterprise2.jpg',
	},
]

export const enterpriseImg = [
	{
		src: window.imgUrl + '/enterprise3.jpg',
	},
	{
		src: window.imgUrl + '/enterprise4.jpg',
	},
	{
		src: window.imgUrl + '/enterprise5.jpg',
	},
	{
		src: window.imgUrl + '/enterprise6.jpg',
	},
	{
		src: window.imgUrl + '/enterprise7.jpg',
	},
	{
		src: window.imgUrl + '/enterprise8.jpg',
	},
	{
		src: window.imgUrl + '/enterprise9.jpg',
	},
	{
		src: window.imgUrl + '/enterprise10.png',
	},
	{
		src: window.imgUrl + '/enterprise11.png',
	},
	{
		src: window.imgUrl + '/enterprise12.jpg',
	},
	{
		src: window.imgUrl + '/enterprise13.png',
	},
	{
		src: window.imgUrl + '/enterprise14.jpg',
	},
	{
		src: window.imgUrl + '/enterprise15.png',
	},
	{
		src: window.imgUrl + '/enterprise16.png',
	},
	{
		src: window.imgUrl + '/enterprise17.jpg',
	},
	{
		src: window.imgUrl + '/enterprise18.jpg',
	},
	{
		src: window.imgUrl + '/enterprise19.png',
	},
	{
		src: window.imgUrl + '/enterprise20.jpg',
	},
	{
		src: window.imgUrl + '/enterprise21.png',
	},
	{
		src: window.imgUrl + '/enterprise22.png',
	},
	{
		src: window.imgUrl + '/enterprise23.png',
	},
	{
		src: window.imgUrl + '/enterprise24.png',
	},
	{
		src: window.imgUrl + '/enterprise25.png',
	},
	{
		src: window.imgUrl + '/enterprise26.jpg',
	},
	{
		src: window.imgUrl + '/enterprise27.png',
	},
	{
		src: window.imgUrl + '/enterprise28.png',
	},
	{
		src: window.imgUrl + '/enterprise29.jpg',
	},
	{
		src: window.imgUrl + '/enterprise30.jpg',
	},
	{
		src: window.imgUrl + '/enterprise31.jpg',
	},
	{
		src: window.imgUrl + '/enterprise32.jpg',
	},
	{
		src: window.imgUrl + '/enterprise33.png',
	},
	{
		src: window.imgUrl + '/enterprise34.png',
	},
	{
		src: window.imgUrl + '/enterprise35.png',
	},
	{
		src: window.imgUrl + '/enterprise36.png',
	},
	{
		src: window.imgUrl + '/enterprise37.png',
	},
	{
		src: window.imgUrl + '/enterprise38.png',
	},
]
